/* Form Page to edit a Character */
import React, { useRef, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Asset from "../../components/Asset";

import Upload from "../../assets/upload.png";
import styles from "../../styles/PostCreateEditForm.module.css";
import appStyles from "../../App.module.css";
import btnStyles from "../../styles/Button.module.css";
import Image from "react-bootstrap/Image";
import Alert from "react-bootstrap/Alert";
import { useCurrentUser } from "../../contexts/CurrentUserContext";

import { useHistory, useParams } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import TopBox from "../../components/TopBox";
import { useRedirect } from "../../hooks/Redirect";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import toast from "react-hot-toast";
import InfoEdit from "./InfoEdit";

const CharacterEdit = () => {
  useRedirect();
  const host = useHostName();
  const [errors, setErrors] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [castOptions, setCastOptions] = useState([]);
  const [selectedCastId, setSelectedCastId] = useState("");
  const currentUser = useCurrentUser();

  const [postData, setPostData] = useState({
    number: "",
    role: "",
    username: "",
    actor: "",
    pickup_address: "",
    pickup_address_2: "",
    make_up_time: "",
    commute_time: "",
    email: "",
    mobile: "",
    agent: "",
    diet: "",
    requirements: "",
    costume1: "",
    costume2: "",
    costume3: "",
    costume4: "",
    costume5: "",
    costume6: "",
    costume7: "",
    makeup: "",
    costume1_image: "",
    costume2_image: "",
    costume3_image: "",
    costume4_image: "",
    costume5_image: "",
    costume6_image: "",
    costume7_image: "",
    makeup_image: "",
  });

  const {
    number,
    role,
    username,
    actor,
    pickup_address,
    pickup_address_2,
    make_up_time,
    commute_time,
    email,
    mobile,
    agent,
    diet,
    requirements,
    costume1,
    costume2,
    costume3,
    costume4,
    costume5,
    costume6,
    costume7,
    makeup,
    costume1_image,
    costume2_image,
    costume3_image,
    costume4_image,
    costume5_image,
    costume6_image,
    costume7_image,
    makeup_image,
  } = postData;

  const imageInput1 = useRef(null);
  const imageInput2 = useRef(null);
  const imageInput3 = useRef(null);
  const imageInput4 = useRef(null);
  const imageInput5 = useRef(null);
  const imageInput6 = useRef(null);
  const imageInput7 = useRef(null);
  const imageInput8 = useRef(null);

  const history = useHistory();
  const { id } = useParams();
  const getUsersPayloadArray = (data) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.results)) return data.results;
    return [];
  };
  const getFullName = (user) =>
    user?.name || `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
  const getCastUserId = (castUser) => {
    if (!castUser) return "";
    if (typeof castUser === "object") {
      return castUser.id ? String(castUser.id) : "";
    }
    return String(castUser);
  };
  const showErrorToast = (err, fallback) => {
    let backendError = fallback;
    if (err?.response?.data?.error) {
      backendError = err.response.data.error;
    } else if (err?.response?.data?.detail) {
      backendError = err.response.data.detail;
    } else if (err?.message) {
      backendError = err.message;
    }
    toast.error(backendError);
  };
  
  useEffect(() => {
    /* Function to fetch the Character data */
    const handleMount = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const response = await axiosReq.get(`/characters/${id}/`);
          if (response?.success === false || response?.status === false) {
            throw response?.error || new Error("Failed to fetch character details");
          }
          const { data } = response;
          const {
            number,
            role,
            actor,
            username,
            pickup_address,
            pickup_address_2,
            make_up_time,
            commute_time,
            email,
            mobile,
            agent,
            diet,
            requirements,
            costume1,
            costume2,
            costume3,
            costume4,
            costume5,
            costume6,
            costume7,
            makeup,
            costume1_image,
            costume2_image,
            costume3_image,
            costume4_image,
            costume5_image,
            costume6_image,
            costume7_image,
            makeup_image,
            cast_user,
          } = data;

          setPostData({
            number,
            role,
            username,
            actor: cast_user?.name || "",
            pickup_address,
            pickup_address_2,
            make_up_time,
            commute_time,
            email: cast_user?.email || "",
            mobile: cast_user?.phone_number || "",
            agent,
            diet,
            requirements,
            costume1,
            costume2,
            costume3,
            costume4,
            costume5,
            costume6,
            costume7,
            makeup,
            costume1_image,
            costume2_image,
            costume3_image,
            costume4_image,
            costume5_image,
            costume6_image,
            costume7_image,
            makeup_image,
          });
          setSelectedCastId(getCastUserId(data?.cast_user));
        } else {
          const response = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/characters/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          );
          if (response?.success === false || response?.status === false) {
            throw response?.error || new Error("Failed to fetch character details");
          }
          const { data } = response;
          const {
            number,
            role,
            actor,
            username,
            pickup_address,
            pickup_address_2,
            make_up_time,
            commute_time,
            email,
            mobile,
            agent,
            diet,
            requirements,
            costume1,
            costume2,
            costume3,
            costume4,
            costume5,
            costume6,
            costume7,
            makeup,
            costume1_image,
            costume2_image,
            costume3_image,
            costume4_image,
            costume5_image,
            costume6_image,
            costume7_image,
            makeup_image,
            cast_user,
          } = data;

          setPostData({
            number,
            role,
            username,
            actor: cast_user?.name || "",
            pickup_address,
            pickup_address_2,
            make_up_time,
            commute_time,
            email: cast_user?.email || "",
            mobile: cast_user?.phone_number || "",
            agent,
            diet,
            requirements,
            costume1,
            costume2,
            costume3,
            costume4,
            costume5,
            costume6,
            costume7,
            makeup,
            costume1_image,
            costume2_image,
            costume3_image,
            costume4_image,
            costume5_image,
            costume6_image,
            costume7_image,
            makeup_image,
          });
          setSelectedCastId(getCastUserId(data?.cast_user));
        }
      } catch (err) {
        console.log(err);
        showErrorToast(err, "Failed to load character.");
      }
    };

    handleMount()
  }, [host, id]);
  useEffect(() => {
    const fetchCastOptions = async () => {
      try {
        let data;
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const response = await axiosReq.get("/users/?group_name=Cast");
          if (response?.success === false || response?.status === false) {
            throw response?.error || new Error("Failed to fetch cast users");
          }
          data = response.data;
        } else {
          const response = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/users/?group_name=Cast`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          );
          if (response?.success === false || response?.status === false) {
            throw response?.error || new Error("Failed to fetch cast users");
          }
          data = response.data;
        }

        setCastOptions(getUsersPayloadArray(data));
      } catch (err) {
        console.log(err);
        showErrorToast(err, "Failed to load cast names.");
      }
    };

    fetchCastOptions();
  }, [host, id]);
console.log(castOptions)
  const handleChange = (event) => {
    const { name, value } = event.target;
    // If the input field is "shot_number", validate it
    if (name === "number" && !/^\d*$/.test(value)) {
      toast.error("A valid number is required", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  /* Clears the chosen Cast Name and the Actor Info fields derived from it */
  const clearCastSelection = () => {
    setSelectedCastId("");
    setPostData((prev) => ({
      ...prev,
      actor: "",
      email: "",
      mobile: "",
      pickup_address: "",
      pickup_address_2: "",
      make_up_time: "",
      commute_time: "",
      agent: "",
      diet: "",
      requirements: "",
    }));
  };

  const handleCastSelection = (event) => {
    const castId = event.target.value;

    if (!castId) {
      clearCastSelection();
      return;
    }
    setSelectedCastId(castId);
      let selectedUser = castOptions.find(
        (user) => String(user?.id) === String(castId)
      );
      if (!selectedUser) {
        return;
      }

      const fullName = getFullName(selectedUser);
      console.log(selectedUser);
      // Editing cast/actor should not wipe existing Makeup/Costumes.
      // Only update the Actor Info fields derived from the selected cast user.
      setPostData((prev) => ({
        ...prev,
        actor: fullName || "",
        email: selectedUser.email || "",
        mobile: selectedUser.phone_number || "",
        // These are also Actor Info fields and should refresh on cast change.
        // If the cast user payload doesn't include them, they reset to empty.
        pickup_address: selectedUser.pickup_address || "",
        pickup_address_2: selectedUser.pickup_address_2 || "",
        make_up_time: selectedUser.make_up_time || "",
        commute_time: selectedUser.commute_time || "",
        agent: selectedUser.agent || "",
        diet: selectedUser.diet || "",
        requirements: selectedUser.requirements || "",
      }));
    };

  const handleChangeImage1 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(costume1_image);
      setPostData({
        ...postData,
        costume1_image: URL.createObjectURL(event.target.files[0]),
      });
      console.log(`costume1_image ${costume1_image}`);
    }
  };

  const handleChangeImage2 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(costume2_image);
      setPostData({
        ...postData,
        costume2_image: URL.createObjectURL(event.target.files[0]),
      });
      console.log(`costume2_image ${costume2_image}`);
    }
  };

  const handleChangeImage3 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(costume3_image);
      setPostData({
        ...postData,
        costume3_image: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleChangeImage4 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(costume4_image);
      setPostData({
        ...postData,
        costume4_image: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleChangeImage5 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(costume5_image);
      setPostData({
        ...postData,
        costume5_image: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleChangeImage6 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(costume6_image);
      setPostData({
        ...postData,
        costume6_image: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleChangeImage7 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(costume7_image);
      setPostData({
        ...postData,
        costume7_image: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleChangeImage8 = (event) => {
    if (event.target.files.length) {
      URL.revokeObjectURL(makeup_image);
      setPostData({
        ...postData,
        makeup_image: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Validate shot_number
    if (!number || !/^\d+$/.test(number)) {
      toast.error("A valid integer is required in Number", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }
    const formData = new FormData();
    // FormData stringifies undefined/null into the text "undefined"/"null",
    // which would then be saved as the field value. Always send a real string.
    const appendField = (name, value) => formData.append(name, value ?? "");

    appendField("role", role);
    appendField("number", number);
    appendField("username", username);
    appendField("actor", actor);
    appendField("pickup_address", pickup_address);
    appendField("pickup_address_2", pickup_address_2);
    appendField("make_up_time", make_up_time);
    appendField("commute_time", commute_time);
    appendField("email", email);
    appendField("mobile", mobile);
    appendField("agent", agent);
    appendField("diet", diet);
    appendField("requirements", requirements);
    appendField("costume1", costume1);
    appendField("costume2", costume2);
    appendField("costume3", costume3);
    appendField("costume4", costume4);
    appendField("costume5", costume5);
    appendField("costume6", costume6);
    appendField("costume7", costume7);
    appendField("makeup", makeup);
    // An empty value unlinks any cast user currently attached to the character.
    appendField("cast_user", selectedCastId);
    if (imageInput1.current.files[0]) {
      formData.append("costume1_image", imageInput1.current.files[0]);
    }
    if (imageInput2.current.files[0]) {
      formData.append("costume2_image", imageInput2.current.files[0]);
    }
    if (imageInput3.current.files[0]) {
      formData.append("costume3_image", imageInput3.current.files[0]);
    }
    if (imageInput4.current.files[0]) {
      formData.append("costume4_image", imageInput4.current.files[0]);
    }
    if (imageInput5.current.files[0]) {
      formData.append("costume5_image", imageInput5.current.files[0]);
    }
    if (imageInput6.current.files[0]) {
      formData.append("costume6_image", imageInput6.current.files[0]);
    }
    if (imageInput7.current.files[0]) {
      formData.append("costume7_image", imageInput7.current.files[0]);
    }
    if (imageInput8.current.files[0]) {
      formData.append("makeup_image", imageInput8.current.files[0]);
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axiosReq.put(`/characters/${id}/`, formData);
        if (response?.success === false || response?.status === false) {
          throw response?.error || new Error("Failed to update character");
        }
        toast.success(`Character "${role}" Updated`);
        history.push(
          `/${localStorage.getItem("projectSlug")}/characters/${id}/`
        );
      } else {
        const response = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/characters/${id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        if (response?.success === false || response?.status === false) {
          throw response?.error || new Error("Failed to update character");
        }
        history.push(
          `/${localStorage.getItem("projectSlug")}/characters/${id}/`
        );
        toast.success(`Character "${role}" Updated Successfully!`);
      }
    } catch (err) {
      console.log(err);
      showErrorToast(err, "Failed to update character.");
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`}
        type="submit"
      >
        Update
      </Button>
    </div>
  );
  return (
    <div>
      <TopBox title={`Edit ${role}`} />
      <Row>
      <Col xs={6} >
        <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      </Col>
      <Col xs={6} >
      <Button
        className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      </Col>
      </Row>
      {!showInfo ? "" : <InfoEdit />}
      <Container className={`px-0 ${appStyles.Content} ${styles.Container}`}>
        <h5 className={`text-center mt-0 mb-2 py-1 ${styles.SubTitle }`}
          style={{ textTransform: 'uppercase'}}>EDIT {role}</h5>
      <Form className="mt-0" onSubmit={handleSubmit}>
              {currentUser &&
              currentUser?.groups.length > 0 &&
              (currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin") && (
              <div>
             <Row>
              <Col xs={6} className="d-flex justify-content-center px-1 mx-0" >
              <Form.Group controlId="role" className={`${styles.Width} text-center`}  >
                      <Form.Label className={`${styles.BoldScene} `} >Role</Form.Label>
                      <Form.Control 
                      className={styles.Input}
                      type="text"
                      name="role"
                      value={role}
                      onChange={handleChange}
                          />
                  </Form.Group>
                  {errors?.role?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
              </Col>
              <Col xs={6} className="text-center " >
              <p className={`${styles.BoldScene} `} >Number</p>
              <p className={`${styles.Number} pt-2`} >{number} </p>
              </Col>
             </Row>
              {/* actor details */}
              <h5 className={`text-center mt-4 mb-3 mb-0 py-0 ${styles.SubTitle }`}>
                ACTOR INFO</h5>
             <Row>
                <Col className='text-center mt-2'>
                <div className='mb-2 mb-md-3'>
                <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall } `} >
                CALLNAME: {username}
                </span>  
                </div>
                </Col>
             </Row>
             <Row className="text-center justify-content-center">
                <Col xs={6} className="d-flex justify-content-center">
                  <Form.Group controlId="cast_name" className={`${styles.Width2} text-center`}>
                    <Form.Label className={styles.BoldScene}>Cast Name</Form.Label>
                    <Form.Control
                      as="select"
                      className={styles.Input}
                      value={selectedCastId}
                      onChange={handleCastSelection}
                      aria-label="cast name select"
                    >
                      <option value="">Select Cast Name</option>
                      {castOptions.map((castUser) => (
                        <option key={castUser.id} value={castUser.id}>
                          {getFullName(castUser) || "Unnamed Cast"}
                        </option>
                      ))}
                    </Form.Control>
                    {selectedCastId && (
                      <Button
                        className={`${btnStyles.ButtonS} ${btnStyles.Grey} mt-2`}
                        onClick={clearCastSelection}
                      >
                        Clear Selection
                      </Button>
                    )}
                  </Form.Group>
                </Col>
             </Row>
             {/* break */}
              <Row>
              <Col xs={12}>
              <hr className={`d-none d-md-block mt-3 mb-3`}/>
              </Col>
              </Row>
             {/* actor mobile */}
              <Row className="text-center">
                  <Col xs={6} className="d-flex justify-content-center"  >
                  <Form.Group controlId="actor" 
                    className={`${styles.Width2} text-center`}  >
                          <Form.Label className={styles.BoldScene} >Actor</Form.Label>
                          <Form.Control 
                          type="text"
                          className={styles.Input}
                          name="actor"
                          value={actor}
                          readOnly
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.actor?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
                  <Col xs={6} className="d-flex justify-content-center" >
                  <Form.Group controlId="mobile" 
                  className={`${styles.Width2} text-center`}  >
                          <Form.Label className={styles.BoldScene} >
                            Mobile</Form.Label>
                          <Form.Control 
                          className={styles.Input}
                          type="text"
                          name="mobile"
                          value={mobile}
                          readOnly
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.mobile?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
              </Row>
              {/* break */}
              <Row>
              <Col xs={12}>
              <hr className={`d-none d-md-block mt-3 mb-3`}/>
              </Col>
              </Row>
              {/* email - address*/}
              <Row className="mt-3 mt-md-0">
                  <Col xs={12} md={6} className="d-flex justify-content-center" >
                  <Form.Group controlId="email"
                  className={`${styles.Width2} text-center`} >
                          <Form.Label className={styles.BoldScene} >Email</Form.Label>
                          <Form.Control 
                          className={styles.Input}
                          type="text"
                          name="email"
                          value={email}
                          readOnly
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.email?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
                  <Col xs={12} md={6} className="mt-3 mt-md-0 d-flex justify-content-center" >
                  <Form.Group controlId="pickup_address" 
                  className={`${styles.Width2} text-center`}>
                          <Form.Label className={styles.BoldScene} >Pickup Address</Form.Label>
                          <Form.Control 
                          type="text"
                          className={styles.InputScene}
                          as="textarea"
                          rows={2}
                          name="pickup_address"
                          value={pickup_address}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.pickup_address?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
              </Row>
              {/* break */}
              <Row >
              <Col xs={12}>
              <hr className={`d-none d-md-block mt-3 mb-3`}/>
              </Col>
              </Row>
              {/* Agent - agent email*/}
              <Row className="mt-3 mt-md-0">
                  {/* Agent - Agent email (using pickup_address_2 for this*/}
                  <Col xs={6}className="d-flex justify-content-center">
                  <Form.Group controlId="agent" 
                   className={`${styles.Width2} text-center`}  >
                          <Form.Label className={styles.BoldScene} >
                            Agent/Agent Phone</Form.Label>
                          <Form.Control 
                          className={styles.Input}
                          type="text"
                          name="agent"
                          value={agent}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.agent?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
                  <Col xs={6} className=" d-flex justify-content-center">
                  <Form.Group controlId="pickup_address_2" 
                    className={`${styles.Width2} text-center`} >
                          <Form.Label className={styles.BoldScene} >Agent Email</Form.Label>
                          <Form.Control 
                          type="text"
                          className={styles.Input}
                          name="pickup_address_2"
                          value={pickup_address_2}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.pickup_address_2?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
              </Row>
              {/* break */}
              <Row >
              <Col xs={12}>
              <hr className={`d-none d-md-block mt-3 mb-3`}/>
              </Col>
              </Row>
              {/* times */}
              <Row className="text-center mt-3 mt-md-0">
                  <Col xs={6} className="d-flex justify-content-center" >
                  <Form.Group controlId="make_up_time" 
                    className={`${styles.Width}`} >
                          <Form.Label className={styles.BoldScene} >Makeup Time</Form.Label>
                          <Form.Control 
                          className={styles.Input}
                          type="text"
                          name="make_up_time"
                          value={make_up_time}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.make_up_time?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
                  <Col xs={6} className="d-flex justify-content-center" >
                  <Form.Group controlId="commute_time" 
                    className={`${styles.Width}`} >
                          <Form.Label className={styles.BoldScene} >Commute Time</Form.Label>
                          <Form.Control 
                          className={styles.Input}
                          type="text"
                          name="commute_time"
                          value={commute_time}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.commute_time?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
              </Row>
              {/* break */}
              <Row >
              <Col xs={12}>
              <hr className={`d-none d-md-block mt-3 mb-3`}/>
              </Col>
              </Row>
             {/* Requirements/Notes */}
             <Row className="text-center mt-3 mt-md-0">
                  {/* Diet */}
                  <Col xs={12} md={6} className="mt-3 mt-md-0 d-flex justify-content-center">
                  <Form.Group controlId="diet" 
                    className={`${styles.Width2} text-center`}>
                          <Form.Label className={styles.BoldScene} >Diet</Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="diet"
                          as="textarea"
                          rows={1}
                          value={diet}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.diet?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
                  <Col xs={12} md={6} className="mt-3 mt-md-0 d-flex justify-content-center" >
                  <Form.Group controlId="requirements" 
                    className={`${styles.Width2} text-center`} >
                          <Form.Label className={styles.BoldScene} >
                            Requirements/Notes</Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="requirements"
                          as="textarea"
                          rows={1}
                          value={requirements}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.requirements?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </Col>
              </Row>
              <Row>
              <Col className="text-center">
              <Button
              className={`${btnStyles.Button} ${btnStyles.Blue} mt-5 px-3 px-md-5`}
              type="submit"
            >
              Update Actor
            </Button>
              </Col>
              </Row>
              </div>
              )}
              <h5 className={`text-center mt-5 mb-4 py-0 ${styles.SubTitle }`}>
                MAKEUP / COSTUMES</h5>
                {/* makeup/costume 1 */}
              <Row className="mt-3 text-center">
                {/* image 8 is  makeup image*/}
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >MAKEUP</p>
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                      <Form.Group>
                        {makeup_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                              src={makeup_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload8"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className=" my-1"
                            htmlFor="image-upload8"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload8"
                          accept="image/*"
                          onChange={handleChangeImage8}
                          ref={imageInput8}
                        />
                      </Form.Group>
                      {errors?.makeup_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                      {/* """ end image 8 """" */}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="makeup" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.BoldScene} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="makeup"
                          as="textarea"
                          rows={1}
                          value={makeup}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.makeup?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
                  {/* image1 */}
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >COSTUME 1</p>
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                    <Form.Group className="text-center">
                        {costume1_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                              src={costume1_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className="d-flex justify-content-center"
                            htmlFor="image-upload"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload"
                          accept="image/*"
                          onChange={handleChangeImage1}
                          ref={imageInput1}
                        />
                      </Form.Group>
                      {errors?.costume1_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="costume1" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.BoldScene} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="costume1"
                          as="textarea"
                          rows={1}
                          value={costume1}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.costume1?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
              </Row>
              <hr className={` mt-3 mb-3 d-none d-md-block`}/>
              {/* costume 2/3 */}
              <Row className="text-center">
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center`} >COSTUME 2</p>
                  {/* image 2 */}
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                      <Form.Group >
                        {costume2_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                              src={costume2_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload2"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className="my-1"
                            htmlFor="image-upload2"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload2"
                          accept="image/*"
                          onChange={handleChangeImage2}
                          ref={imageInput2}
                        />
                      </Form.Group>
                      {errors?.costume2_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                      {/* """ end image 2 """" */}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="costume2" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.Bold} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="costume2"
                          as="textarea"
                          rows={1}
                          value={costume2}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.costume2?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center`} >COSTUME 3</p>
                  {/* image 3 */}
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                      <Form.Group>
                        {costume3_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                              src={costume3_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload3"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className=" my-1"
                            htmlFor="image-upload3"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload3"
                          accept="image/*"
                          onChange={handleChangeImage3}
                          ref={imageInput3}
                        />
                      </Form.Group>
                      {errors?.costume3_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                      {/* """ end image 3 """" */}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="costume3" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.Bold} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="costume3"
                          as="textarea"
                          rows={1}
                          value={costume3}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.costume3?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
              </Row>
              <hr className={`${styles.Break1Cos} mt-3 mb-3 d-none d-md-block`}/>
              {/* costume 4/5  */}
              <Row className="text-center">          
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center`} >COSTUME 4</p>
                  {/* image 4 */}
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                      <Form.Group>
                        {costume4_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                              src={costume4_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload4"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className=" my-1"
                            htmlFor="image-upload4"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload4"
                          accept="image/*"
                          onChange={handleChangeImage4}
                          ref={imageInput4}
                        />
                      </Form.Group>
                      {errors?.costume4_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                      {/* """ end image 4 """" */}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="costume4" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.Bold} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="costume4"
                          as="textarea"
                          rows={1}
                          value={costume4}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.costume4?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >COSTUME 5</p>
                  {/* image 5 */}
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                      <Form.Group>
                        {costume5_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                               src={costume5_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload5"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className=" my-1"
                            htmlFor="image-upload5"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload5"
                          accept="image/*"
                          onChange={handleChangeImage5}
                          ref={imageInput5}
                        />
                      </Form.Group>
                      {errors?.costume5_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                      {/* """ end image 5 """" */}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="costume5" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.BoldScene} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="costume5"
                          as="textarea"
                          rows={1}
                          value={costume5}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.costume5?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
              </Row>
              <hr className={`${styles.Break1Cos} mt-3 mb-3 d-none d-md-block`}/>
              {/* costume 6/7  */}
              <Row className="text-center">
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >COSTUME 6</p>
                  {/* image 6 */}
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                      <Form.Group>
                        {costume6_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                               src={costume6_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload6"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className=" my-1"
                            htmlFor="image-upload6"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload6"
                          accept="image/*"
                          onChange={handleChangeImage6}
                          ref={imageInput6}
                        />
                      </Form.Group>
                      {errors?.costume6_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                      {/* """ end image 6 """" */}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="costume6" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.Bold} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="costume6"
                          as="textarea"
                          rows={1}
                          value={costume6}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.costume6?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
                  <Col xs={12} md={6} >
                  <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >COSTUME 7</p>
                  {/* image 7 */}
                  <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                      <Form.Group>
                        {costume7_image ? (
                          <>
                            <figure>
                              <Image 
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                              src={costume7_image} rounded />
                            </figure>
                            <div>
                              <Form.Label
                                className={`${btnStyles.Button} ${btnStyles.Blue}`}
                                htmlFor="image-upload7"
                              >
                                Change the image
                              </Form.Label>
                            </div>
                          </>
                        ) : (
                          <Form.Label
                            className=" my-1"
                            htmlFor="image-upload7"
                          >
                            <Asset
                              src={Upload}
                              message="Upload Image"
                            />
                          </Form.Label>
                        )}
          
                        <Form.Control
                          type="file"
                          id="image-upload7"
                          accept="image/*"
                          onChange={handleChangeImage7}
                          ref={imageInput7}
                        />
                      </Form.Group>
                      {errors?.costume7_image?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                      {/* """ end image 7 """" */}
                  </div>
                  <div className="d-flex justify-content-center">
                  <Form.Group controlId="costume7" 
                    className={`${styles.Width2}`} >
                          <Form.Label className={styles.Bold} ></Form.Label>
                          <Form.Control 
                          className={styles.InputScene}
                          type="text"
                          name="costume7"
                          as="textarea"
                          rows={1}
                          value={costume7}
                          onChange={handleChange}
                              />
                      </Form.Group>
                      {errors?.costume7?.map((message, idx) => (
                        <Alert variant="warning" key={idx}>
                          {message}
                        </Alert>
                      ))}
                  </div>
                  <hr className={`${styles.Break1Cos} d-block d-md-none mt-4`}/>
                  </Col>
              </Row>
              <hr className={`${styles.Break1Cos} mt-3 mb-3 d-none d-md-block`}/>
              <Row>
                <Col>
                  <Container className= {`${styles.Container} mt-3`} >{buttons} </Container>
                </Col>
              </Row>
              </Form>
      </Container>
    </div>
  );
};

export default CharacterEdit;
